import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/images/map.svg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4" }
const _hoisted_4 = { class: "dropdown action-opt" }
const _hoisted_5 = { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }
const _hoisted_6 = { class: "px-0 mb-0 list-unstyled border-top pt-12" }
const _hoisted_7 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_8 = { class: "flex-shrink-0" }
const _hoisted_9 = {
  class: "d-flex align-items-center",
  style: {"gap":"8px"}
}
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "mb-0 fs-14 fw-medium lh-1 text-body" }
const _hoisted_12 = { class: "flex-grow-1 ms-3" }
const _hoisted_13 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_14 = {
  class: "progress-responsive",
  style: {"width":"120px"}
}
const _hoisted_15 = ["aria-valuenow"]
const _hoisted_16 = { class: "count text-body ms-3 fs-14 fw-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "mb-0" }, "Sales By Country", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("button", {
            class: "btn bg-transparent p-0",
            type: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, [
            _createElementVNode("i", {
              "data-feather": "more-vertical",
              style: {"stroke":"#64748b"}
            })
          ], -1)),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setTimeRange('day')))
              }, " This Day ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTimeRange('week')))
              }, " This Week ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTimeRange('month')))
              }, " This Month ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTimeRange('year')))
              }, " This Year ")
            ])
          ])
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "ext-center",
        style: {"margin":"25px 0"}
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "map"
        })
      ], -1)),
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCountries, (country) => {
          return (_openBlock(), _createElementBlock("li", {
            key: country.code,
            class: "mb-12 pb-12 border-bottom"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("img", {
                    src: _ctx.getFlagImage(country.code),
                    style: {"width":"24px"},
                    alt: country.name
                  }, null, 8, _hoisted_10),
                  _createElementVNode("h4", _hoisted_11, _toDisplayString(country.name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", {
                      class: "progress rounded-pill",
                      style: {"height":"5px","background-color":"#ecf0ff"},
                      role: "progressbar",
                      "aria-valuenow": country.percentage,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }, [
                      _createElementVNode("div", {
                        class: "progress-bar rounded-pill",
                        style: _normalizeStyle(`width: ${country.percentage}%; height: 5px; background-color: ${country.color}`)
                      }, null, 4)
                    ], 8, _hoisted_15)
                  ]),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(country.percentage) + "% ", 1)
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}